export default {
  getProcessosComissoes(state) {
    return state.processosComissoes;
  },
  getFiltros(state) {
    return state.filtros;
  },
  getCampos(state) {
    return state.campos;
  },
};
